export interface LightingAdvisorLight {
  sku: string;
  lightCategory: string | null;
  lightType: string | null;
  lightColor: string | null;
  peakWavelengthTypical: string | null;
  maxObjectSize: { length: number | null; width: number | null };
  workingDistanceMax: number | null;
  mount: string | null;
  isStandard: boolean;
  price: number | null;
  relatedCameraSkus: string[];
  relatedAccessorySkus: string[];
}

export interface LightingAdvisorCamera {
  sku: string;
  series: string | null;
  modelName: string | null;
  slpFeature: boolean;
  monocolor: string | null;
  mount: string | null;
}

export interface LightingAdvisorAccessory {
  sku: string;
  modelName: string | null;
  type: string | null;
  accessoryType: string | null;
  cableLength: number | null;
}

export interface LightingAdvisorCatalog {
  lights: LightingAdvisorLight[];
  cameras: LightingAdvisorCamera[];
  accessories: LightingAdvisorAccessory[];
  mounts: string[];
}

export interface LightingAdvisorAccessoryRecommendations {
  availableSkus: string[];
  selectedSkus: string[];
  furtherSkus: string[];
  warningIdentifiers: string[];
}

export interface LightingAdvisorScoredLight {
  sku: string;
  lightCategory: string | null;
  score: number;
  price: number | null;
  bestFitValue: number | null;
  best_price?: 1;
  best_fit?: 1;
}

export interface LightingAdvisorDecoration {
  type: 'warning' | 'flag';
  identifier: string;
  ordernumber?: string | null;
  questionId?: string | null;
}

export const DEFAULT_LIGHT_FUNCTIONS = ['flashing'] as const;
